document.addEventListener('DOMContentLoaded', function () {
  const registryEl = document.getElementById('auto-gift-registry');
  if (!registryEl) return;

  const registry = JSON.parse(registryEl.textContent || '{}');
  if (Object.keys(registry).length === 0) return;

  let processing = false;

  function checkAndSync() {
    if (processing) return;
    processing = true;

    fetch('/cart.js')
      .then((r) => r.json())
      .then(async (cart) => {
        const cartVariantIds = cart.items.map((i) => i.variant_id.toString());
        const toAdd = [];

        cart.items.forEach((item) => {
          const vId = item.variant_id.toString();
          const giftId = registry[vId];
          if (giftId && !cartVariantIds.includes(giftId.toString())) {
            toAdd.push({
              id: giftId,
              quantity: 1,
              properties: { _cadeau_auto: 'true', _associe_a: vId },
            });
          }
        });

        const orphan = cart.items.find(
          (i) => i.properties?._cadeau_auto === 'true' && !cartVariantIds.includes(i.properties._associe_a)
        );

        if (toAdd.length) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: toAdd }),
          });
        }
        if (orphan) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: orphan.key, quantity: 0 }),
          });
        }

        if (toAdd.length || orphan) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .finally(() => {
        processing = false;
      });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, checkAndSync);
});